module.exports = __webpack_public_path__ + "img/img72.24ee0704.svg";